import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { FlyInTransition } from '../../components/transitions/transitions';
import Modal from '../common/Modal';
import Player from './PodcastPlayer';
import Header from '../../components/common/Header';

const OuterContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  align-items: stretch;
  overflow: hidden;
  background: white;
`;

const BodyContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 16px;
  padding-bottom: 100px;
`;
const AlbumImage = styled.img`
  border-radius: 8px;
`;

const HoverContent = styled.div`
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.9) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  position: absolute;
  padding: 12px 11px;
  bottom: 0px;
  left: 0px;
  border-radius: 0px 0px 8px 8px;
  width: 100%;
  color: #ffffff;
`;

const CardTitle = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  color: #ffffff;
`;

const CardDescription = styled.div`
  font-weight: 600;
  font-size: 10px;
  line-height: 12px;
  display: flex;
  align-items: center;
  color: #e6e6e6;
  margin-top: 2px;
`;

const ModalContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
`;

const SeeAllPodcasts = function (props) {
  const { state } = props.location;
  const card = state.card;
  const [showPlayerModal, setShowPlayerModal] = useState(false);
  const [selectedAlbum, setSelectedAlbum] = useState(null);
  const { authToken } = useSelector((state) => state.user);
  const history = useHistory();

  const playPodcast = (album) => {
    if (album.showAudioPlayer) {
      setShowPlayerModal(true);
      setSelectedAlbum(album);
    } else {
      history.push('/health-content/sub-podcasts', {
        albumId: album.albumId,
      });
    }
  };

  const hideModal = () => {
    setShowPlayerModal(false);
  };

  const renderPodcastCards = (card) => {
    const albums = card.albums;
    return (
      <div className="">
        {albums && albums.length > 0 && (
          <div className="grid grid-cols-2 gap-4">
            {albums.map((album) => {
              return (
                <button
                  onClick={() => playPodcast(album)}
                  style={{ position: 'relative' }}
                  className="text-left"
                >
                  <AlbumImage src={album.imageUrl} />
                  <HoverContent>
                    <CardTitle>{album.albumTitle}</CardTitle>
                    <CardDescription>{album.coachName}</CardDescription>
                  </HoverContent>
                </button>
              );
            })}
          </div>
        )}
      </div>
    );
  };
  return (
    <OuterContainer>
      <Header title={card.title} />
      <BodyContainer>
        <div>{renderPodcastCards(card)}</div>
      </BodyContainer>
      {showPlayerModal && (
        <Modal>
          <ModalContainer onClick={hideModal}>
            <FlyInTransition
              in={showPlayerModal}
              mountOnEnter
              unmountOnExit
              appear
            >
              <Player
                album={selectedAlbum}
                authToken={authToken}
                hideModal={hideModal}
              />
            </FlyInTransition>
          </ModalContainer>
        </Modal>
      )}
    </OuterContainer>
  );
};

export default SeeAllPodcasts;
